module.exports = __webpack_public_path__ + "assets/settings-edc56b.svg";